import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getBiometricUrl } from "services/company-service";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Row, Col, Layout, Spin } from "antd";
import { AuthHeader } from "components";
import * as authAction from "actions/auth-action";
import { DarkColor, SoftColor } from "config/constants/Color";
import { useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { getBiometricUserUrlsByToken } from "services/user-service";

export default function BiometricScreen() {
    const [searchParams] = useSearchParams();
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const token = searchParams.get("token");
    const entity = searchParams.get("entity");

    useEffect(() => {
        loadBiometric();
    }, [token]);

    async function loadBiometric() {
        if (token) {
            setLoading(true);
            let response;
            if(entity === 'shareholder') {
                response = await getBiometricUrl(token);
            } else {
                response = await getBiometricUserUrlsByToken(token);
            }
            const url = entity === "legalRepresentative"? response.tutorUrl: response.url;
            setLoading(false);
            window.location.href = url;
        }
    }

  return (
    <Layout
        style={{
            backgroundColor: SoftColor,
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
        }}
    >
        <Layout.Content>
            <Row justify="center" align="middle" className="login">
                <Col xxl={7} xl={8} lg={12} md={16} sm={24} xs={24}>
                    {loading && (
                        <Card
                            title={<AuthHeader />}
                            bordered={false}
                            className="card-login"
                            style={{ textAlign: "center", background: DarkColor}}
                            headStyle={{ borderBottom: "none" }}
                        >
                            <div style={{ marginBottom: "16px", color: "white" }}>
                                Aguarde um instante, você será redirecionado para efetuar a biometria.
                            </div>
                            <Spin
                                size="large"
                                style={{ display: "block" }}
                                indicator={<LoadingOutlined style={{ fontSize: 32, color: "white" }} spin />}
                            />
                        </Card>
                    )}
                </Col>
            </Row>
        </Layout.Content>
    </Layout>
  );
}